import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import type { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '@env';

import { getAuthProviders, getMonitoringProviders, provideEnv } from '@evc/platform';
import { getI18nProviders } from '@shared/services/i18n/i18n.provider';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnv(environment),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    ...getAuthProviders(environment),
    ...getI18nProviders(),
    ...getMonitoringProviders(),
  ],
};
